import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';
import AirbnbCalendar from './AirbnbCalendar';

const VillaInfo = () => {
  const { t } = useTranslation();
  const [openGroups, setOpenGroups] = useState({});

  // Helper to wrap each block separated by "|"
  const renderCapacity = () => {
    const capacityText = t('villa.capacity');
    return capacityText.split('|').map((block, idx) => (
      <span key={idx} style={{ margin: '0 4px' }}>{block.trim()}</span>
    ));
  };

  return (
    <div>
      <section className='sectionInfo'>
        <div className='sectionInfo-top'>
          <div>
            <h2>{t('villa.videoTitle')}</h2>
            <video width="100%" height="auto" controls>
              <source src="/videos/hero.mp4" type="video/mp4" />
              {t('video.notSupported')}
            </video>
          </div>
          <div>
            <AirbnbCalendar lang={i18n.language} />
          </div>
        </div>
        <div className='sectionInfo-bottom'>
          <h2>{t('villa.title')}</h2>
          <p><strong>{t('villa.subtitle')}</strong></p>
          <p className='capacity'> {renderCapacity()}</p>
          <p className='description'>{t('villa.description')
            .split('\n')
            .map((line, index) => (
              <span key={index}>
                {line}
                <br />
              </span>
            ))}</p>
          {/* <button>{t('button.quote')}</button> */}
        </div>
      </section>
      <section className='sectionPool'>
        <h2>{t('villa.poolVideoTitle', { defaultValue: 'La piscina in video' })}</h2>
        <div className='poolVideos'>
          <video className='poolVideo' controls playsInline preload="metadata">
            <source src="/videos/piscine-rotate.mp4" type="video/mp4" />
            {t('video.notSupported')}
          </video>
        </div>
      </section>
      <section className='sectionAmenities'>
        <h2>{t('amenities.title')}</h2>
        <div className='amenitiesGroups'>
          {t('amenities.groups', { returnObjects: true }).map((group, idx) => {
            const maxItems = 5;
            const showMore = group.items.length > maxItems;
            const isOpen = openGroups[idx];
            const displayedItems = isOpen ? group.items : group.items.slice(0, maxItems);
            return (
              <div key={idx} className='amenitiesGroup'>
                <h3>{group.title}</h3>
                <ul>
                  {displayedItems.map((item, itemIdx) => (
                    <li key={itemIdx}>
                      {item.name}
                      {item.details && (
                        <span className='amenityDetails'> — {item.details}</span>
                      )}
                    </li>
                  ))}
                </ul>
                {showMore && !isOpen && (
                  <a
                    className="showMoreLink"
                    onClick={() => setOpenGroups({ ...openGroups, [idx]: true })}
                  >
                    {t('amenities.showMore', { count: group.items.length - maxItems })}
                  </a>
                )}
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
};

export default VillaInfo;
